/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForCostAnomaly extends models.GovernanceConfigurationBaseForCostAnomaly {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForCostAnomaly");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForCostAnomaly.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForCostAnomaly>): GovernanceConfigurationForCostAnomaly {
        let obj = Object.assign(new GovernanceConfigurationForCostAnomaly(), model);
        GovernanceConfigurationForCostAnomaly.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForCostAnomaly>): GovernanceConfigurationForCostAnomaly {
        if (!model) return null;
        return GovernanceConfigurationForCostAnomaly.newInstance(<GovernanceConfigurationForCostAnomaly> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForCostAnomaly) {
        if (!obj) return;

        models.GovernanceConfigurationForCostAnomaly.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForCostAnomaly): boolean {
        if (models.GovernanceConfigurationBaseForCostAnomaly.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForCostAnomaly.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.minimum_cost_spend === undefined) {
            this.minimum_cost_spend = 0;
        }
        if (this.minimum_cost_impact === undefined) {
            this.minimum_cost_impact = 0;
        }
        if (this.minimum_cost_impact_percentage === undefined) {
            this.minimum_cost_impact_percentage = 0;
        }
    }

    /**
     * Cost anomaly settings category.
     */
    category: models.CostAnomalySettingCategory;

    /**
     * List of categories.
     */
    category_values: Array<string>;

    /**
     * Minimum Cost Spend
     */
    minimum_cost_spend: number;

    /**
     * Minimum Cost Impact
     */
    minimum_cost_impact: number;

    /**
     * Minimum Cost Anomaly Impact Percentage
     */
    minimum_cost_impact_percentage: number;

    /**
     * Cost Impact and Spend condition
     */
    cost_impact_spend_operator: models.CostImpactSpendOperator;

}
